
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x-core-3",
      function () {
        return require("private-next-pages/x-core-3/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x-core-3"])
      });
    }
  